import React from 'react';
import { updateSpace } from '../../app-main/actions/space';
import { SubmissionError } from 'redux-form';
import { pickBy } from 'lodash';
import { FormattedMessage } from 'react-intl';

const onSubmitCleaning = (values = {}, dispatch, props) => {
  const { spaceId, accessToken, isEdit } = props;
  const payload = {};
  const {
    description,
    cleaning_measures: cleaningMeasures,
    signage,
    physical_distance: physicalDistance,
    protective_gear: protectiveGear
  } = values;


  const errorComponent = <FormattedMessage id="hosting.on_submit_cleaning.error_message" defaultMessage="Submission failed. Please refresh and try again." />;

  const objToArray = (object) => {
    return Object.keys(pickBy(object, val => val));
  };

  payload.cleaning_info = {
    description,
    cleaning_measures: objToArray(cleaningMeasures),
    signage: objToArray(signage),
    physical_distance: objToArray(physicalDistance),
    protective_gear: objToArray(protectiveGear)
  };


  return dispatch(updateSpace(spaceId, accessToken, payload))
    .then(() => {
      // NOTE: add analytics here
      if (isEdit) {
        window.location.href = `/your-space/${spaceId}`;
        return null;
      }

      window.location.href = `/your-space/${spaceId}/cancellation-policy`;
    })
    .catch((error) => {
      throw new SubmissionError({ _error: error || errorComponent });
    });
};

export default onSubmitCleaning;
